export default __webpack_public_path__ + "img/11.asset.120ee270.jpeg";